import React, { useEffect, useState } from "react";

import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import { LabelField } from "components";
import Loader from "components/loader/Loader";
import moment from "moment";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import { DateFormetContext } from "../../../app/App.js";
import Charge from "./ChargeType/Charge";
import CreditOnAccount from "./ChargeType/CreditOnAccount";
import Donation from "./ChargeType/Donation";

const types = ["Charge", "Donation", "Credit On Account"];

const ChargeDetails = ({ ...props }) => {
  const [state, setState] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [accountName, setAccountName] = useState(false);

  const orgDetails = getOrganizationInfoFromLocalStorage();



  const PayAllValue = useSelector((state) => state.homeReducer.ShowPayALlValue);

  const [show, setShow] = useState(
    props?.values?.values[0]?.charge_type === "donation" ||
      PayAllValue?.[0]?.charge_type === "donation"
      ? "Donation"
      : PayAllValue?.[0]?.charge_type === "credit_on_account" ||
        props?.values?.values[0]?.charge_type === "credit_on_account"
        ? "Credit On Account"
        : "Charge"
  );

  useEffect(() => {
    setState((prev) => [...prev, show]);
  }, [show]);

  const dateFormet = React.useContext(DateFormetContext);
  const getAddCharge = () => {
    setAccountName(false);
    setRefresh(true);
    const enableHandleNext = props.values?.values?.every((item) => {
      const { Ledger, due_date, payment_date, total_amount, charge_type } =
        item;
      return !!(
        Ledger &&
        (charge_type === "credit on account" ||
          charge_type === "credit_on_account" ||
          due_date) &&
        payment_date &&
        total_amount
      );
    });
    if (enableHandleNext) {
      props.setValues({
        ...props.values,
        values: [
          ...props.values.values,
          {
            account_name: props?.values?.account_name?.name,
            tax_type: props?.values?.values?.[0]?.tax_type ?? "%",
            discount_type: props?.values?.values?.[0]?.discount_type ?? "%",
            payment_date: moment(new Date())
              .utcOffset("+0100")
              .format(dateFormet?.replaceAll("/", "-")),
            note: "",
            comment_checkbox: false,
            is_splitted: false,
            total_amount: 0,
            charge_type:
              show === "Credit On Account"
                ? "credit_on_account"
                : show === "Charge"
                  ? "charge"
                  : "donation",
            // due_date: moment(new Date())
            //   .add(1)
            //   .utcOffset("+0100")
            //   .format(dateFormet?.replaceAll("/", "-")),
          },
        ],
      });
    } else {
      toastr.info("Validation", "Please fill all the required fields first");
    }
  };
  useEffect(() => {
    if (!props.values.tribute_information)
      props.setFieldValue("tribute_information", props.values.account_name);
  }, [props.values.account_name]);

  const removeCharge = (idx) => {
    const checksList = [...props.values?.values];
    checksList.splice(idx, 1);
    props.setValues({
      ...props.values,
      values: [...checksList],
    });
  };

  useEffect(() => {
    const containsTrue = props?.values?.values?.length > 1 && props?.values?.values?.some(item => item?.isRecurring === true);

    if (containsTrue) {
      props.setValues({
        ...props.values,
        values: [props.values?.values?.[0]],
      });
    }

  }, [props.values])

  const renderComponent = (index) => {
    switch (show) {
      case "Charge":
        return (
          <Charge
            index={index}
            types={types}
            setShow={setShow}
            show={show}
            removeCharge={removeCharge}
            setRefresh={setRefresh}
            accountName={accountName}
            setAccountName={setAccountName}
            refresh={refresh}
            enableInstallments={orgDetails?.allowInstallments}
            {...props}
          />
        );
      case "Donation":
        return (
          <Donation
            index={index}
            types={types}
            setShow={setShow}
            show={show}
            setRefresh={setRefresh}
            refresh={refresh}
            removeCharge={removeCharge}
            accountName={accountName}
            setAccountName={setAccountName}
            enableInstallments={orgDetails?.allowInstallments}
            {...props}
          />
        );
      case "Credit On Account":
        return (
          <CreditOnAccount
            index={index}
            types={types}
            setShow={setShow}
            removeCharge={removeCharge}
            accountName={accountName}
            setAccountName={setAccountName}
            show={show}
            enableInstallments={orgDetails?.allowInstallments}
            {...props}
          />
        );
      default:
        return (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </div>
        );
    }
  };

  return (
    <div className="">
      {props.values?.values?.map((_, index) => {
        return <p>{renderComponent(index)}</p>;
      })}
      {!props.values?.values?.[0]?.isRecurring && <div>
        {props.values?.isTransactionSave ? null : (
          <div
            className={`d-flex pl-30 pt-3 ${props?.values?.account_name?.name ? "" : "grey-color"
              }`}
            onClick={getAddCharge}
          >
            <span className="cursor-pointer px-3">
              <AddIcon />
            </span>
            <span className="add-show">
              <LabelField
                title={`Add ${show === "Charge" ? "transaction" : show}`}
                color={`#2555ef`}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
        )}
      </div>}
    </div>
  );
};

export default ChargeDetails;